import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../ui/tabs';
import DocumentValidationWorkflowTable from './DocumentValidationWorkflowTable';
import type { Document } from '../../../api/documentApi';

interface DocumentValidationWorkflowTabsProps {
  pendingDocs: Document[];
  approvedDocs: Document[];
  rejectedDocs: Document[];
  statusColors: Record<string, string>;
  onReview: (document: Document) => void;
}

export default function DocumentValidationWorkflowTabs({
  pendingDocs,
  approvedDocs,
  rejectedDocs,
  statusColors,
  onReview,
}: DocumentValidationWorkflowTabsProps) {
  const [activeTab, setActiveTab] = useState('pending');

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab}>
      <TabsList>
        <TabsTrigger value="pending">Pending ({pendingDocs.length})</TabsTrigger>
        <TabsTrigger value="approved">Approved ({approvedDocs.length})</TabsTrigger>
        <TabsTrigger value="rejected">Rejected ({rejectedDocs.length})</TabsTrigger>
      </TabsList>

      <TabsContent value="pending">
        <DocumentValidationWorkflowTable
          documents={pendingDocs}
          statusColors={statusColors}
          onReview={onReview}
          type="pending"
        />
      </TabsContent>

      <TabsContent value="approved">
        <DocumentValidationWorkflowTable
          documents={approvedDocs}
          statusColors={statusColors}
          onReview={onReview}
          type="approved"
        />
      </TabsContent>

      <TabsContent value="rejected">
        <DocumentValidationWorkflowTable
          documents={rejectedDocs}
          statusColors={statusColors}
          onReview={onReview}
          type="rejected"
        />
      </TabsContent>
    </Tabs>
  );
}
